module.exports = __webpack_public_path__ + "assets/images/amira_celebration_default.ac6b9dc12b7749c4874f77a721014333.svg";